var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldStrongbox2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.81 2C4.17 2 2 4.17 2 7.81v8.37C2 19.83 4.17 22 7.81 22h8.37c3.64 0 5.81-2.17 5.81-5.81V7.81C22 4.17 19.83 2 16.19 2H7.81zM18 9.24h-2a.749.749 0 1 0 0 1.5h2c.55 0 1 .45 1 1v.51c0 .55-.45 1-1 1h-2c-.41 0-.75.34-.75.75s.34.75.75.75h2c.55 0 1 .45 1 1V16c0 1.66-1.34 3-3 3H8c-1.66 0-3-1.34-3-3v-.5c0-.55.45-1 1-1h1.48a2.5 2.5 0 0 0 2.49-2.76c-.13-1.3-1.32-2.24-2.63-2.24H6c-.55 0-1-.45-1-1V8c0-1.66 1.34-3 3-3h8c1.66 0 3 1.34 3 3v.24c0 .55-.45 1-1 1zM6 11h1c.55 0 1 .45 1 1s-.45 1-1 1H6c-.55 0-1-.45-1-1s.45-1 1-1z",
    fill: "{props.color}",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldStrongbox2);
export default __webpack_public_path__ + "static/media/vuesax-bold-strongbox-2.ea7d9bae480e6988b22b7876e1a00554.svg";
export { ForwardRef as ReactComponent };